// extracted by mini-css-extract-plugin
module.exports = {"Info_Board":"InfoBoard_Info_Board__3yVAl","Info_Board_Item":"InfoBoard_Info_Board_Item__TWKhc"};